
const SAVE_SETTINGS = '[settings][app]save';

export {SAVE_SETTINGS}